// extracted by mini-css-extract-plugin
export default {"PhotoCropInput":"bfl_a"};